import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarePlan } from 'src/app/calvin-emr-shared/models/care-plan.model';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonDirective } from 'primeng/button';
import { doc, getDoc, getFirestore, Timestamp } from '@angular/fire/firestore';
import { PatientDashboardTabComponent } from '../dashboard-tab/dashboard-tab.component';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/calvin-emr-shared/services/patient.service';

import { ToastModule } from 'primeng/toast';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-care-plan-tab',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatTooltipModule,
    ButtonDirective,
    TextareaModule,
    TooltipModule,
    ToastModule

  ],
  providers: [MessageService],
  templateUrl: './care-plan-tab.component.html',
  styleUrl: './care-plan-tab.component.scss'
})
export class CarePlanTabComponent extends PatientDashboardTabComponent implements OnInit {
  carePlan: CarePlan = new CarePlan();

  patient: Patient | undefined;

  form = this.fb.group({
    noticing: ['', Validators.required],
    interpreting: ['', Validators.required],
    responding: ['', Validators.required],
    reflecting: ['', Validators.required],
  });

  constructor(
    private fb: UntypedFormBuilder,
    patientStore: PatientDashboardStore,
    store: Store,
    private patientService: PatientService,
    private messageService: MessageService
  ) {
    super(patientStore, store);
    this.patient$.subscribe((patient: Patient) => {
      this.patient = patient;
      this.loadCarePlan();
    });
  }

  ngOnInit(): void { }

  private loadCarePlan(): void {
    const carePlanData = (this.patient as any)?.carePlanNotes;

    if (carePlanData) {
      this.carePlan = new CarePlan(
        carePlanData.noticing,
        carePlanData.interpreting,
        carePlanData.responding,
        carePlanData.reflecting,
        carePlanData.lastUpdated
      );

      this.prefillForm(this.carePlan);
      // console.log("Prefilled care plan:", this.carePlan);
    } else {
      // console.log("No existing care plan found.");
    }
  }

  private prefillForm(carePlan: CarePlan): void {
    this.form.patchValue({
      noticing: carePlan.noticing || '',
      interpreting: carePlan.interpreting || '',
      responding: carePlan.responding || '',
      reflecting: carePlan.reflecting || '',
    });
  }


  private updateCarePlanFromForm(): void {
    this.carePlan.noticing = this.noticingFormControl.value;
    this.carePlan.interpreting = this.interpretingFormControl.value;
    this.carePlan.responding = this.respondingFormControl.value;
    this.carePlan.reflecting = this.reflectingFormControl.value;
    this.carePlan.lastUpdated = Timestamp.now();
  }

  onSave(): void {
    const patientId = this.patient?.id;
    if (!patientId) {
      console.error('Error: Patient ID not available.');
      return;
    }

    this.updateCarePlanFromForm();

    this.patientService.updatePatientField(patientId, 'carePlanNotes', {
      noticing: this.carePlan.noticing,
      interpreting: this.carePlan.interpreting,
      responding: this.carePlan.responding,
      reflecting: this.carePlan.reflecting,
      lastUpdated: this.carePlan.lastUpdated,
    }).subscribe({
      next: () => {
        console.log('Care plan notes saved in patient record!');
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Care plan updated successfully!'
        })
      },
      error: (error: any) => {
        console.error('Error saving care plan notes:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update care plan.'
        })
      }
    });
  }



  get noticingFormControl(): UntypedFormControl {
    return this.form.controls.noticing as UntypedFormControl;
  }

  get interpretingFormControl(): UntypedFormControl {
    return this.form.controls.interpreting as UntypedFormControl;
  }

  get respondingFormControl(): UntypedFormControl {
    return this.form.controls.responding as UntypedFormControl;
  }

  get reflectingFormControl(): UntypedFormControl {
    return this.form.controls.reflecting as UntypedFormControl;
  }
}
